<template>
    <div class="career">
        <div class="nav">
            <div class="navs">
                <img src="imgs/careerhome/icon_xitong.png" alt="" class="xitong">
              <span class="title" style="color:#3D90F6">
                    生涯发展管理平台
                </span>
                <div class="navRight">
                    <b @click="personCenter()">
                        <img :src="person" alt="" style="width:42px">
                        <span>{{uName}}</span>
                    </b>&nbsp; | &nbsp;
                    <a @click="Jump('/login')" style="color:#3D90F6">退出</a>
                </div>
            </div>
        </div>
        
        <div class="careerBox">
            <div class="left" :style="{height:routers.length==1?60+'px':routers.length*44+32+'px'}" v-if="mobile">
                <ul class="routers">
                    <router-link v-for="item,index in routers" tag="li"   :to="{path:index!=0?item.link:'/careerArchives'}"   :class="index == 0 ? 'home' : ''"
                    >
                        <img :src="imgs[index]+'.png'" alt="" class="unactive ">
                        <!-- <img :src="imgs[index]+'.png'" alt="" class="active" v-if="index!=0"> -->
                    {{ item.name }}
                    </router-link>
                </ul>
            </div>
            <div class="right">
                <div class="rightBottom">
                    <!--<transition name="transitionRouter">-->
                        <router-view></router-view>
                    <!--</transition>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        metaInfo () {
            return {
                title: this.Pctitle,
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: this.copyright.keywords,
                }],
                link: [{                 // set link
                    rel: 'icon',
                    href: this.copyright.mark
                }]
            }
        },   
        name: "index",
        data(){
            return {
                Pctitle:'',
                copyright:[],
                mobile:true,
                routers:[],
                imgs:[
                    "imgs/careerhome/nav/icon_shouye",
                    "imgs/careerhome/nav/icon_shengxuetujing",
                    "imgs/careerhome/nav/icon_renshiziwo",
                    "imgs/careerhome/nav/icon_waibutansuo",
                    "imgs/careerhome/nav/icon_xingaokaoxuanke",
                    "imgs/careerhome/nav/icon_xuanzejuece",
                    "imgs/careerhome/nav/icon_xingdongjihua",
                    'imgs/careerhome/nav/icon_xuankezhenduan',
                    "imgs/careerhome/nav/icon_zhuangtaizixun",
                    //"imgs/careerhome/nav/icon_chengzhangdangan",
                    "imgs/careerhome/nav/icon_shipinkecheng"
                ],
                message:['imgs/careerhome/icon_tongzhi.png','imgs/careerhome/icon_youxiaoxi.png'],
                person:'imgs/careerhome/icon_boy.png',
                uName:'',
                noticeNumber:0,
                days:'',
                hours:'',
                minutes:'',
                seconds:'',
                teacherId:'',
                height_school_id:'',
            }
        },
        methods:{
            // 个人中心
            personCenter(){
                this.$router.push('/personalCenter')
            },
            //获取导航
            get_nav(){
              let _this = this;
              this.$ajax
              .post(this.G_uri + '/career/getLeftList', 
                {agentHighSchoolId:this.height_school_id},
                {
                  headers: {
                    token: window.sessionStorage.getItem("ymtxToken"),
                    
                  }
                }
               ) 
              .then((res)=>{                                  
                if(res.data.code == 2000){                                        
                        const newRoute= [{
                            img:'',
                            id: 0,
                            link: '/careerArchives',
                            list: [],
                            name: "首页",
                            pid: 0,
                            sort: 999,
                        },...res.data.data];
                        _this.routers=newRoute;
                        
                        for(var i=0;i<_this.routers.length;i++){
                           var item = _this.routers[i];
                           if(item.name == '咨询管理'){
                               if(this.$store.state.studentStatus==3){
                                   newRoute[i].link = '/studyPlan'                                   
                                //    
                               }else{
                                   newRoute[i].link = '/studyPlan/studentQues'
                               }
                           }
                        }                       
                        this.$store.commit('getRouteConfig', newRoute);                   
                }else if(res.data.code == 2026){
                    _this.$message.error(res.data.msg);
                    _this.$router.push('/perfectInformation');
                }
              })
            },          
            //高考倒计时
            countDown(year){
                let time=new Date(year,5,7).getTime()/1000;
                let nowTime=new Date().getTime()/1000;
                this.days=Math.floor((time-nowTime)/3600/24)
                this.hours=Math.floor((time-nowTime)/3600%24)
                this.minutes=Math.floor((time-nowTime)/60%60)
                this.seconds=Math.floor((time-nowTime)%60)
                this.hours=this.hours<10?"0"+this.hours:this.hours
                this.minutes=this.minutes<10?"0"+this.minutes:this.minutes
                this.seconds=this.seconds<10?"0"+this.seconds:this.seconds
            },
            Jump(path){
                window.sessionStorage.clear();
                window.localStorage.clear();
                this.$router.push(path);
            },
            // 获取版权信息
            get_footer_copyright(){
                var OEMdomain = this.$OEMdomain=='localhost'?'http://39.98.37.134':this.$OEMdomain,
                _this = this;
                this.$ajax.post(this.G_uri + '/website/getConfigInfo', {
                    webSite: OEMdomain
                }).then(function(res){
                    if(res.data.code == 2000){
                        console.log(res)
                        _this.copyright = res.data.data;
                        _this.Pctitle = res.data.data.title
                    }
                })
            }, 
        },
        computed:{
            //用户信息
            user(){
                return this.$store.state.user
            },
            unreadNum(){
                return this.$store.state.notice.unreadNum
            },           
            
        },
        watch: {
            user(val){
                console.log(val);
                this.height_school_id = val.agent_high_school_id;
                this.uName=val.name;
                this.teacherId=val.teacher_id;
                if(val.sex==1){
                    this.person='imgs/careerhome/icon_boy.png'
                }else{
                    this.person='imgs/careerhome/icon_girl.png'
                }
                this.countDown(val.baccll_year)
                setInterval(()=>{
                    this.countDown(val.baccll_year)
                },1000)
                this.get_nav();
            },           
        },
        created() {
            let token= window.sessionStorage.getItem('ymtxToken');
            window.sessionStorage.setItem('token', token);
            window.sessionStorage.getItem('ymtxToken');
               ///获取个人信息
         
            this.$store.dispatch({
                type:'getUserInfo',
                token:token,
                vue:this
            });
            this.uName=this.user.name;
            this.height_school_id = this.user.agent_high_school_id;
            this.teacherId=this.user.teacher_id;
            this.countDown(this.user.baccll_year)
            //获取未读通知
            this.$store.dispatch('getUnreadNum',token);
            //获取省市区
            this.$store.dispatch('getCitys');
        },
        mounted(){
            this.$store.dispatch('getStudentStatus',window.sessionStorage.getItem('ymtxToken'));
            // this.mobile = window.sessionStorage.getItem('from_eq')=='mobile'?false:true 
            this.get_footer_copyright();
        }
    }
</script>
<style scoped lang="less">
   .navRight > b{
       font-weight: inherit;
   }
    .career{
        //background: #F3F4F8;
        padding-bottom: 20px;
        height: 100%;
        .nav{
            width: 100%;
            height: 66px;
            background: #fff;
            overflow: hidden;
            // display: none;
            .navs{
                width: 1200px;
                height: 100%;
                position: relative;
                margin:0 auto;
                line-height:66px;
                font-size:13px;
                color:#333;
                .navRight{
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: auto;
                    height: 100%;
                    cursor: pointer;
                    span{
                        letter-spacing: 2px;
                    }
                    img{
                        margin-right: 10px;
                    }
                    .tongzhi{
                        margin-right:40px;
                    }
                    .tongzhiImg{
                        cursor: pointer;
                    }
                    a{
                        color:#333;
                        letter-spacing: 1.5px;
                    }
                }
                .xitong{
                    width: 36px;
                    height: auto;
                    margin-right:5px;
                    position: relative;
                    top:-1px;
                }
                .rili{
                    margin-right: 5px;
                }
                .title{
                    font-size: 17px;
                    color:#333333;
                    letter-spacing: 2px;
                    text-align: center;
                    font-weight: bolder;
                    margin-right: 38px;
                }
                .number{
                    color:red;
                    margin-right: 3px;
                    font-weight: bolder;
                }
            }
        }
        .careerBox{
            margin: 20px auto;
            overflow: hidden;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            .left{
                width: 160px;
                height: 430px;
                margin-top: 1px;
                float: left;
                background: #fff;
                border-radius: 3px;
                box-shadow: 0 0 3px #dedede;
                position: relative;
                z-index: 3;
                // display: none;
                .routers{
                    li{
                        height: 44px;
                        width: 100%;
                        line-height: 44px;
                        font-size: 14px;
                        text-indent: 22px;
                        color:#666;
                        /*font-weight: bolder;*/
                        //letter-spacing: 2px;
                        cursor: pointer;
                        transition: 0.2s;
                        &:nth-child(1){
                            line-height: 60px;
                            height: 60px;
                            font-size: 16px;
                            border-bottom: 1px solid #F7F6FB;
                            //color:#333333;
                            //font-weight: normal;
                        }
                        img{
                            margin-right: 15px;
                            position: relative;
                            top:-2px;
                        }
                        .active {
                            display: none;
                        }
                        .unactive {
                            display: inline-block;
                        }
                    }
                    .router-link-active {
                        font-weight:bolder;
                        color:#3C8CEB;
                    }
                    .home {
                        background: none;
                         .active {
                            display: none;
                        }
                        .unactive {
                            display: inline-block;
                        }
                    }
                }
            }
            .right{
                width: 1044px;
                float: left;
                .rightTop{
                    width: 100%;
                    height: 65px;
                    background: #fff;
                    border-radius: 3px;
                    box-shadow: 0 0 3px #dedede;
                }
            }
        }
    }
</style>

